import React, { memo } from "react";

import useTranslation from "next-translate/useTranslation";

import RenderStringHtml from "shared/components/atoms/RenderStringHtml";
import Widget from "shared/components/templates/Widget/index";
import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";

import { DescriptionContainer } from "./styles";

const Description = ({ course }) => {
  const { t, lang } = useTranslation();
  const description = course && course.description;
  const descriptionTranslated = staticIntlTranslatorToString(description, lang);

  return (
    <DescriptionContainer>
      {description && !Array.isArray(description) && (
        <Widget
          transparentDarkDisabled
          styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
          title={t("common:description")}
        >
          <p>
            <RenderStringHtml
              value={descriptionTranslated.replace(
                "<a",
                '<a target="_blank" rel="noopener noreferrer"',
              )}
            />
          </p>
        </Widget>
      )}
    </DescriptionContainer>
  );
};

export default memo(Description);
